import React from "react";
import {
  deleteProviderAccounts,
  getProviderList,
} from "../../../api/providers";
import { Box, Stack, Typography } from "@mui/material";
import LGModalCrud from "../../LGCrud/LGModalCrud";
import ProviderContactList from "../ProviderContactList";
import BankAccountList from "../BankAccountList";
import ActivityTable from "../ActivityTable";
import CrudProviderContract from "../ContractTable";
import ProviderForm from "../ProviderForm.tsx";
import ProviderVisualization from "../ProviderVisualization";
import { getUserRoles } from "../../../services/auth";

export default function CrudProviderAccounts({ props }) {

  const baseRoles = ["Admin", "Superadmin"];

  const { companyId } = props;
  const {roles} = getUserRoles();
  const canCreate = [...baseRoles, "Contador", "Auxiliar Contable"] 
  const canUpdate = [...baseRoles, "Contador", "Auxiliar Contable"]
  const canDelete = [...baseRoles, "Contador", "Auxiliar Contable"]

  const showCreateButton = canCreate.some(role => roles.includes(role));
  const showUpdateButton = canUpdate.some(role => roles.includes(role));
  const showDeleteButton = canDelete.some(role => roles.includes(role));


  const actions = ["detail", "visualize"];
  actions.push(showCreateButton ? "create" : "");
  actions.push(showUpdateButton ? "update" : "");
  actions.push(showDeleteButton ? "delete" : "");

  const handleDelete = async (id, row) => {
    // Use Provider.Account.Id instead of provider.Id
    let accountId = row?.account?.id;
    
    if (!accountId && row?.accounts) {
      const accounts = Array.isArray(row.accounts) ? row.accounts : [];
      const defaultAccount = accounts.find(acc => acc.IsDefault || acc.isDefault);
      accountId = defaultAccount?.Id || defaultAccount?.id || accounts[0]?.Id || accounts[0]?.id;
    }

    return deleteProviderAccounts(accountId);
  };

  return (
    <>
      <Box width={"100%"}>
        <LGModalCrud
          props={{
            actions: actions,
            data: { companyId },
            fetchFunction: getProviderList,
            deleteFunction: handleDelete,
            visualizeModalData: {
              header: "Visualizar Proveedor",
              body: <ProviderVisualization />,
            },
            detailMenu: [
              {
                label: "Dirección y Contacto",
                handler: () => {},
                header: "Contactos del proveedor",
                body: <ProviderContactList />,
              },
              {
                label: "Info. Bancaria",
                handler: () => {},
                header: "Información bancaria",
                body: <BankAccountList />,
              },
              {
                label: "Actividades",
                handler: () => {},
                header: "Actividades del proveedor",
                body: <ActivityTable />,
              },
              {
                label: "Documentos",
                handler: () => {},
                header: "Lista de Documentos del proveedor",
                body: <CrudProviderContract />,
              },
            ],
            columns: [
              {
                field: "code",
                headerName: "Clave",
                flex: 0.2,
              },
              {
                field: "legalName",
                headerName: "Nombre o razón social",
                flex: 0.3,
              },
              {
                field: "taxId",
                headerName: "RFC / Tax ID",
                flex: 0.2,
              },
              {
                field: "accounts",
                headerName: "Cuentas contables",
                flex: 0.5,
                renderCell: (params) => (
                  <Stack direction={"column"}>
                    {params.value
                      .filter((e) => e.companyId === companyId)
                      .map((e) => (
                        <Typography variant="body2" key={e.id}>
                          {e.contpaqiAccountNo} - {e.description}
                        </Typography>
                      ))}
                  </Stack>
                ),
              },
            ],
            addModalData: {
              header: "Agregar Proveedor",
              body: <ProviderForm companyId={companyId} />,
            },
            editModalData: {
              header: "Editar Proveedor",
              body: <ProviderForm companyId={companyId} />,
            },
          }}
        />
      </Box>
    </>
  );
}
